import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useSignalR } from './useSignalR';
import { message } from 'antd';

interface StockUpdatedEvent {
  productId: string;
  newQty: number;
}

interface LowStockAlertEvent {
  productId: string;
  sku: string;
  qty: number;
}

interface ExpiryAlertEvent {
  batchId: string;
  expiryDate: string;
}

export function useWarehouseHub() {
  const { on } = useSignalR({ hubPath: 'warehouse' });
  const queryClient = useQueryClient();

  useEffect(() => {
    const unsub1 = on<StockUpdatedEvent>('StockUpdated', (_mdData) => {
      queryClient.invalidateQueries({ queryKey: ['warehouse', 'stock'] });
    });

    const unsub2 = on<LowStockAlertEvent>('LowStockAlert', (data) => {
      message.warning(`Низький залишок: ${data.sku} — ${data.qty} од.`);
    });

    const unsub3 = on<ExpiryAlertEvent>('ExpiryAlert', (data) => {
      message.warning(`Наближається термін придатності: партія закінчується ${data.expiryDate}`);
    });

    return () => {
      unsub1?.();
      unsub2?.();
      unsub3?.();
    };
  }, [on, queryClient]);
}
